import { useEffect, useState, useRef } from "react";
import AppConst from "../apis/appconst";
import AddDoctor from '../models/AddDoctor';
import axios from "axios";
import { toast } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import JsBarcode from 'jsbarcode';
import ReactDOM from 'react-dom';
import Select from 'react-select';
import Swal from "sweetalert2";
// at top of your file with other imports
import 'sweetalert2/dist/sweetalert2.min.css';

// Replace your jspdf imports with:
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import QRCode from "qrcode";

// treat "YYYY-MM-DD" from <input type="date"> as local start / end-of-day
function parseInputDateStart(yyyyMmDd) {
  if (!yyyyMmDd) return null;
  const parts = String(yyyyMmDd).split('-');
  if (parts.length !== 3) return new Date(yyyyMmDd);
  const y = Number(parts[0]), m = Number(parts[1]) - 1, d = Number(parts[2]);
  return new Date(y, m, d, 0, 0, 0); // local midnight
}
function parseInputDateEnd(yyyyMmDd) {
  if (!yyyyMmDd) return null;
  const parts = String(yyyyMmDd).split('-');
  if (parts.length !== 3) return new Date(yyyyMmDd);
  const y = Number(parts[0]), m = Number(parts[1]) - 1, d = Number(parts[2]);
  return new Date(y, m, d, 23, 59, 59, 999); // local end of day
}

function Registrations() {
  // return YYYY-MM-DD for the browser's local date (not UTC)
// return YYYY-MM-DD for the browser's local date (not UTC)
const getLocalDateYYYYMMDD = () => {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};
// near other refs at top of component
const sessionLoadedRef = useRef(false);

// normalize ANY incoming date-like value to local YYYY-MM-DD
function normalizeToLocalYYYYMMDD(input) {
  if (!input && input !== 0) return getLocalDateYYYYMMDD();
  const s = String(input).trim();

  // already YYYY-MM-DD -> return as-is
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;

  // MySQL-ish "YYYY-MM-DD HH:mm:ss" or "YYYY-MM-DDTHH:mm:ss..."
  const mysqlLike = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}):?(\d{2})?)?/);
  if (mysqlLike) {
    const y = Number(mysqlLike[1]);
    const m = Number(mysqlLike[2]) - 1;
    const d = Number(mysqlLike[3]);
    // construct local Date using components so no timezone shift
    const dt = new Date(y, m, d);
    return `${dt.getFullYear()}-${String(dt.getMonth()+1).padStart(2,'0')}-${String(dt.getDate()).padStart(2,'0')}`;
  }

  // ISO or other string -> let Date parse then extract the local date parts
  const parsed = new Date(s);
  if (!isNaN(parsed.getTime())) {
    const yy = parsed.getFullYear();
    const mm2 = String(parsed.getMonth() + 1).padStart(2, '0');
    const dd2 = String(parsed.getDate()).padStart(2, '0');
    return `${yy}-${mm2}-${dd2}`;
  }

  // fallback to local today
  return getLocalDateYYYYMMDD();
}



// helper: clears 0 on focus
// helper: clears 0 on focus (for age and amount fields)
const handleFocus = (e) => {
  const name = e.target.name;
  // If it's an age field and 0, clear it
  if (["lab_reg_age_year", "lab_reg_age_month", "lab_reg_age_day"].includes(name)) {
    if (e.target.value === "0" || e.target.value === "0.00") {
      e.target.value = "";
      const fakeEvent = { target: { name, value: "" } };
      handleChange(fakeEvent);
    }
  } 
  // If it's a payment field, same logic
  else if (["lab_dis_per", "lab_fix_deposit", "lab_paid"].includes(name)) {
    if (e.target.value === "0" || e.target.value === "0.00") {
      e.target.value = "";
    }
  }
};

// helper: restores 0 if empty on blur (for age and numeric fields)
const handleBlur = (e) => {
  const name = e.target.name;
  // If empty, restore 0 only for age and money fields
  if (["lab_reg_age_year", "lab_reg_age_month", "lab_reg_age_day", "lab_dis_per", "lab_fix_deposit", "lab_paid"].includes(name)) {
    if (e.target.value === "" || e.target.value === null) {
      e.target.value = "0";
      const fakeEvent = { target: { name, value: "0" } };
      handleChange(fakeEvent);
    }
  }
};




    const inputRef = useRef();
    const [finalprice, setFinalprice] = useState(0);
    const [isSaved, setIsSaved] = useState(false)
    const [Name, setName] = useState('');
    const [image, setImage] = useState('')
    const [ldata, setLdata] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [ageAutoZero, setAgeAutoZero] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
const [showSearchDropdown, setShowSearchDropdown] = useState(false);
// near other refs
const selectRef = useRef(null);
const [pendingReferralToResolve, setPendingReferralToResolve] = useState(null);

    const [showCollectedDropdown, setShowCollectedDropdown] = useState(false);
    
    const patientNameRef = useRef(null);
const ageYearRef = useRef(null);


       // STATE TO STORE THE ORIGINAL LAB_REG_TYPE for comparison
    const [originalLabRegType, setOriginalLabRegType] = useState("");

    // Added state to control UHID readonly or editable
    const [isUHIDReadOnly, setIsUHIDReadOnly] = useState(false);
    const referralInputRef = useRef(null);
// Broker select state
const [brokerOptions, setBrokerOptions] = useState([]);
const [brokerId, setBrokerId] = useState('');       // selected broker id (string)
const [brokerLabel, setBrokerLabel] = useState(''); // selected broker label / name
const [loadingBrokers, setLoadingBrokers] = useState(false);

// debounce ref for type-ahead
const brokerDebounceRef = useRef(null);

    const [formData, setFormData] = useState({
        tests1: [],
        docs: [],
        users: [],
        lab_reg_id: '',
        lab_reg_uhid: '',
        lab_reg_name_title: 'Mr.',
        lab_reg_name: '',
        lab_reg_gender: 'male',
        lab_reg_address: '',
        lab_reg_type: 'Direct',
        lab_reg_age_year: '0',
        lab_reg_age_month: '0',
        lab_reg_age_day: '0',
        lab_reg_city: '',
        lab_reg_state: '',
        lab_reg_mobile: '',
        lab_reg_referral: '',
        lab_reg_sample: '',
        lab_reg_date: '',
        lab_guardian_title: '',
        lab_guardian_name: '',
        lab_collected_at: '',
        lab_total: '0',
        lab_dis_per: '0',
        lab_fix_deposit: '0',
        lab_final_amt: '0',
        lab_paid: '0',
        lab_due: '0',
        lab_pay_mode: 'Cash',
        lab_remarks: '',
        lab_reg_user: '',
        page_no: 0,
        alertMsg: '',
        alertMsgTyp: '',
        search_key: '',
        isAlert: false,
    });
// DEBUG & resilient docs loader (put this after your formData useState)
const [fetchError, setFetchError] = useState(null);
const [referralId, setReferralId] = useState('');
const [docSearch, setDocSearch] = useState('');
const [showReferralDropdown, setShowReferralDropdown] = useState(false);
const [filteredDoctors, setFilteredDoctors] = useState([]);

// Toggle this to true to force sample doctors (UI test)
const USE_MOCK_DOCTORS = false;

const MOCK_DOCTORS = [
  { user_id: "d1", fname: "Dr. Ameet", lname: "Shah", doc: { doc_degree: "MBBS", doc_specality: "Cardiology" } },
  { user_id: "d2", fname: "Dr. Leena", lname: "Patel", doc: { doc_degree: "MD", doc_specality: "Gynec" } },
  { user_id: "d3", fname: "Dr. Rohan", lname: "K", doc: { doc_degree: "MS", doc_specality: "Ortho" } }
];

const loadDoctorsForLab = async () => {
  try {
    setFetchError(null);

    if (USE_MOCK_DOCTORS) {
      // Allow mock for UI verification
      setFormData(prev => ({ ...prev, docs: MOCK_DOCTORS }));
      setFilteredDoctors(MOCK_DOCTORS);
      console.warn("Using MOCK_DOCTORS - backend not used");
      return;
    }

    console.log("[Lab] loadDoctorsForLab: starting fetch...");
    const fd = new FormData();
    fd.append('type', "doctor");
    fd.append('search_key', ""); // ensure server returns default list
    fd.append('page_no', "none");
    fd.append('user_cre_by', "1");

    const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
      // add auth headers if your app requires them:
      // headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
    });

    console.log("[Lab] doctors response raw:", response); // <<<<<< inspect this in console
    const payload = response?.data || {};

    // Support multiple response shapes:
    const candidates = payload.records || payload.users || payload.data || payload.result || [];

    // If server returns an object with nested records, try to find it:
    let records = candidates;
    if (!Array.isArray(records)) {
      // try to find first array inside payload
      const arr = Object.values(payload).find(v => Array.isArray(v));
      records = arr || [];
    }

    // Optional: if backend uses status boolean
    if (payload.status === false) {
      console.warn("[Lab] server returned status:false", payload);
      // still attempt to use records if present
    }

    if (!Array.isArray(records)) {
      console.error("[Lab] parsed records is not an array", records);
      setFetchError("Invalid doctor list received from server");
      // fallback to empty
      setFormData(prev => ({ ...prev, docs: [] }));
      setFilteredDoctors([]);
      return;
    }

    // normalize ids & names
    const normalized = records.map(r => {
      const id = r.user_id ?? r.id ?? r._id ?? r.userId ?? "";
      const fname = String(r.fname ?? r.first_name ?? r.name ?? "").trim();
      const lname = String(r.lname ?? r.last_name ?? "").trim();
      const docObj = r.doc ?? r.doctor ?? r.profile ?? {};
      return { ...r, user_id: id, fname, lname, doc: docObj };
    });

    setFormData(prev => ({ ...prev, docs: normalized }));
    setFilteredDoctors(normalized);

    console.log("[Lab] doctors normalized:", normalized);
  } catch (err) {
    console.error("[Lab] loadDoctorsForLab error:", err);
    setFetchError(err.message || String(err));
    // try graceful fallback
    setFormData(prev => ({ ...prev, docs: [] }));
    setFilteredDoctors([]);
  }
};

// run once on mount
useEffect(() => {
  loadDoctorsForLab();
}, []);



useEffect(() => {
  if (!pendingReferralToResolve) return;

  // prefer filteredDoctors (if you're using that) otherwise fallback to formData.docs
  const docs = (filteredDoctors && filteredDoctors.length) ? filteredDoctors : (formData.docs || []);
  if (!docs || docs.length === 0) {
    // wait until docs are loaded
    return;
  }

  const ref = String(pendingReferralToResolve).trim();
  // try matching by id first, then by full name, then by first name fallback
  let found = docs.find(d =>
    String(d.user_id ?? d.id ?? "").trim() === ref ||
    (`${(d.fname || "").trim()} ${(d.lname || "").trim()}`.trim()) === ref ||
    (d.fname || "").trim() === ref
  );

  if (found) {
    const fullName = `${(found.fname || "").trim()} ${(found.lname || "").trim()}`.trim();
    setReferralId(String(found.user_id));      // react-select expects id in referralId
    setDocSearch(fullName);                    // optional: keep the typed search in sync
    setFormData(prev => ({ ...prev, lab_reg_referral: fullName }));
  } else {
    // no doctor found — show the raw label in control but leave referralId empty
    setReferralId("");
    setDocSearch(ref);
    setFormData(prev => ({ ...prev, lab_reg_referral: ref }));
  }

  setPendingReferralToResolve(null);
}, [pendingReferralToResolve, filteredDoctors, formData.docs]);

    // Portal dropdown that positions below the target input
function PortalDropdown({ anchorRef, open, children, onSelect }) {
  const elRef = useRef(null);
  if (!elRef.current) elRef.current = document.createElement('div');

  useEffect(() => {
    const el = elRef.current;
    document.body.appendChild(el);
    return () => {
      if (el.parentNode) el.parentNode.removeChild(el);
    };
  }, []);

  // compute position
  const [style, setStyle] = useState({});

  useEffect(() => {
    if (!open || !anchorRef?.current) return setStyle({ display: 'none' });

    const rect = anchorRef.current.getBoundingClientRect();
    const top = rect.bottom + window.scrollY;
    const left = rect.left + window.scrollX;
    const width = rect.width;

    setStyle({
      position: 'absolute',
      top: `${top}px`,
      left: `${left}px`,
      minWidth: `${width}px`,
      maxHeight: '220px',
      overflowY: 'auto',
      zIndex: 99999,
      boxShadow: '0 6px 18px rgba(0,0,0,0.12)',
      background: '#fff',
      borderRadius: '4px',
      border: '1px solid rgba(0,0,0,0.08)',
      padding: '4px 0'
    });
  }, [open, anchorRef?.current, window.innerWidth, window.innerHeight]); // reposition on open

  if (!open) return null;

  return ReactDOM.createPortal(
    <div style={style} role="listbox">
      {children}
    </div>,
    elRef.current
  );
}

// REPLACE your entire handleChange function with this simpler version:

// place near other helpers inside your component
const barcodeCanvasRef = useRef(null);

const generateBarcodeDataUrl = (value, options = {}) => {
  const canvas = barcodeCanvasRef.current || document.createElement('canvas');
  const v = (value && String(value).trim()) ? String(value).trim() : 'NA';
  try {
    JsBarcode(canvas, v, {
      format: options.format || 'CODE128',
      width: options.width || 2,
      height: options.height || 60,
      displayValue: options.displayValue === undefined ? false : options.displayValue,
      margin: options.margin || 5,
      textMargin: 0
    });
    return canvas.toDataURL('image/png');
  } catch (err) {
    console.error('Barcode generation failed', err);
    return null;
  }
};

const escapeHtml = (unsafe) => {
  if (!unsafe) return '';
  return String(unsafe)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
};

/**
 * Print using a hidden iframe to avoid popup blocker.
 * Trigger must be a user click (e.g. onClick handler) — then the browser will allow printing.
 */
const printThermalBarcodeIframe = async (patientName, age, uhid) => {
  // 1) Generate barcode data URL
  const barcodeData = generateBarcodeDataUrl(uhid, { width: 2, height: 70, displayValue: false });

  // 2) build printable HTML
  const css = `
    <style>
      @media print {
        @page { size: 80mm auto; margin: 4mm; }
        body { -webkit-print-color-adjust: exact; -webkit-print-color-adjust: exact; }
      }
      body {
        font-family: Arial, Helvetica, sans-serif;
        margin: 0;
        padding: 6px;
        color: #000;
        width: 280px; /* ~80mm */
      }
      .ticket { text-align:center; padding:2px 4px; }
      .title { font-size:14px; font-weight:700; margin-bottom:6px; }
      .meta { font-size:12px; margin:2px 0; }
      .uhid { font-size:12px; font-weight:700; margin-top:6px; }
      .barcode { margin-top:8px; }
      img.barimg { max-width:100%; height:auto; }
      .small { font-size:10px; color:#333; margin-top:6px; }
    </style>
  `;

  const html = `<!doctype html><html><head><meta charset="utf-8"/><title>Print Barcode</title>${css}</head>
    <body>
      <div class="ticket">
        
        <div class="meta">Name: ${escapeHtml(patientName || 'N/A')}</div>
        <div class="meta">Age: ${escapeHtml(age || 'N/A')}</div>
        <div class="uhid">UHID: ${escapeHtml(uhid || 'N/A')}</div>
        <div class="barcode">${ barcodeData ? `<img class="barimg" src="${barcodeData}" alt="${escapeHtml(uhid)}"/>` : '<div style="height:60px">Barcode error</div>' }</div>
        <div class="small">Generated: ${new Date().toLocaleString()}</div>
      </div>
    </body></html>`;

  // 3) create a hidden iframe (reuse if already present)
  const existing = document.getElementById('thermal-print-iframe');
  let iframe;
  if (existing) {
    iframe = existing;
    // clear previous content
    iframe.srcdoc = 'about:blank';
  } else {
    iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    iframe.id = 'thermal-print-iframe';
    document.body.appendChild(iframe);
  }

  // Write html into the iframe and wait for it to load
  return new Promise((resolve, reject) => {
    const onLoad = () => {
      try {
        const iwin = iframe.contentWindow;
        // wait for barcode image to load inside iframe (if present)
        const imgs = iframe.contentDocument.getElementsByTagName('img');
        if (imgs.length === 0) {
          // no image to wait for — print immediately
          iwin.focus();
          iwin.print();
          // optional: remove iframe after a short timeout to avoid interfering
          setTimeout(() => { /* keep iframe for reuse; remove if you prefer */ }, 500);
          resolve(true);
        } else {
          // wait for all images to load
          let loadedCount = 0;
          const checkDone = () => {
            loadedCount++;
            if (loadedCount >= imgs.length) {
              try {
                iwin.focus();
                iwin.print();
                resolve(true);
              } catch (err) {
                reject(err);
              }
            }
          };
          for (let img of imgs) {
            if (img.complete) checkDone();
            else img.addEventListener('load', checkDone);
            img.addEventListener('error', () => {
              // still attempt to print even if image fails
              checkDone();
            });
          }
        }
      } catch (err) {
        reject(err);
      }
    };

    // Use srcdoc if supported — it avoids navigation and is immediate
    if ('srcdoc' in iframe) {
      iframe.onload = onLoad;
      iframe.srcdoc = html;
    } else {
      // fallback for older browsers: write into document
      iframe.onload = onLoad;
      const doc = iframe.contentDocument || iframe.contentWindow.document;
      doc.open();
      doc.write(html);
      doc.close();
    }

    // safety: timeout rejects if printing fails to start in N seconds
    setTimeout(() => {
      // resolve anyway rather than leaving hanging; you can choose to reject
      resolve(false);
    }, 8000);
  }).catch(err => {
    console.error('Print iframe error', err);
    return false;
  });
};

// remove duplicate imports at top if present:
// import Swal from "sweetalert2";

// remove duplicate imports: ensure only one `import Swal from "sweetalert2";` at top

const handleChange = (e) => {
  const { name, value } = e.target;

  // use functional setState to avoid race conditions
  setFormData((prev) => {
    // copy prev
    const next = { ...prev, [name]: value };

    // preserve your UHID logic
    if (name === "lab_reg_type") {
      if (value !== originalLabRegType) setIsUHIDReadOnly(false);
      else setIsUHIDReadOnly(true);
    }

    // If user is typing into Paid field, allow empty string and validate when non-empty
    if (name === "lab_paid") {
      // allow clearing the field
      if (value === "" || value === null) {
        next.lab_paid = "";
        // if final amount exists, recalc due as final - 0
        const finalAmt = parseFloat(prev.lab_final_amt || "0") || 0;
        next.lab_due = finalAmt.toFixed(2);
        return next;
      }

      // parse numeric
      const paidNum = Number(value);
      const finalNum = Number(prev.lab_final_amt || "0");

      // if not a number, ignore change (or set to empty)
      if (isNaN(paidNum)) {
        // keep previous value
        return prev;
      }

      if (paidNum > finalNum) {
        // warn and DO NOT set the invalid paid value
        Swal.fire({
          icon: "warning",
          title: "Invalid Amount",
          text: "Paid amount cannot be greater than the final amount!",
          confirmButtonColor: "#3085d6"
        });
        return prev;
      }

      // valid paid -> update paid and due
      next.lab_paid = paidNum.toString();
      next.lab_due = (finalNum - paidNum).toFixed(2);
      return next;
    }

    // If updating final amount manually (rare in your form but safe to handle)
    if (name === "lab_final_amt") {
      // allow empty
      if (value === "" || value === null) {
        next.lab_final_amt = "";
        // leave paid as-is, recalc due
        const paidNum = Number(prev.lab_paid || 0) || 0;
        next.lab_due = (0 - paidNum).toFixed(2); // likely negative — your UI may not use empty final
        return next;
      }

      const finalNum = Number(value);
      if (isNaN(finalNum)) return prev;

      // if existing paid exceeds new final -> warn and cap paid (or you can choose to block)
      const paidNum = Number(prev.lab_paid || 0) || 0;
      if (paidNum > finalNum) {
        Swal.fire({
          icon: "warning",
          title: "Paid exceeds Final",
          text: "Paid amount is greater than the new final amount — it will be adjusted to the final amount.",
          confirmButtonColor: "#3085d6"
        });
        next.lab_final_amt = finalNum.toString();
        next.lab_paid = finalNum.toFixed(2);
        next.lab_due = "0.00";
        return next;
      }

      next.lab_final_amt = finalNum.toString();
      next.lab_due = (finalNum - paidNum).toFixed(2);
      return next;
    }

    // For other fields, just return next. totals will be recalculated by useEffect below.
    return next;
  });
};



// helper to fetch tests by search key
const fetchTests = async (searchKey = "") => {
  try {
    setIsLoading(true);

    const fd = new FormData();
    fd.append("type", "test");
    fd.append("search_key", searchKey);
    fd.append("page_no", "none");
    fd.append("test_user", 1);

    const response = await axios.post(AppConst.BASE_URL + AppConst.getTestListUrl, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    if (response.data && response.data.status) {
      setSearchResults(response.data.records || []);
    } else {
      setSearchResults([]);
    }
  } catch (err) {
    console.error("fetchTests error", err);
    setSearchResults([]);
  } finally {
    setIsLoading(false);
  }
};

// Validate phone number format
const validatePhoneNumber = (phone) => {
  const phoneRegex = /^[6-9]\d{9}$/; // Indian mobile number format
  return phoneRegex.test(phone);
};

// Validate UHID format (if you have specific format)
const validateUHID = (uhid) => {
  if (!uhid) return true; // UHID is optional during creation
  return uhid.length >= 8; // Minimum length check
};

// Format amount for display
const formatAmount = (amount) => {
  return parseFloat(amount || 0).toFixed(2);
};
//  const handleSubmit = async (e) => {
//     e.preventDefault();

//     const missing = [];

//     if (!referralId || String(referralId).trim() === "") {
//       missing.push("Referral Doctor (select from list)");
//     }
  
//     if (!formData.lab_reg_name || String(formData.lab_reg_name).trim() === "") {
//       missing.push("Patient Name");
//     }
  
//        // Age validation (allow 0 if ageAutoZero is true)
//      // allow 0 age — treat 0 as valid (newborn / unknown age)
// const ageYears = formData.lab_reg_age_year;
// if (ageYears === '' || ageYears === null || ageYears === undefined) {
//   missing.push("Age (Years)");
// }

//        // if ageAutoZero === true, we accept age = 0 (intentional unknown/newborn)
   
  
//     console.log("[Lab] missing fields:", missing);
  
//     if (missing.length > 0) {
//       const listHtml = missing.map(m => `<li>${m}</li>`).join("");
//       Swal.fire({
//         icon: "warning",
//         title: "Missing required fields",
//         html: `<p>Please complete the following before submitting:</p><ul style="text-align:left">${listHtml}</ul>`,
//         confirmButtonText: "OK"
//       }).then(() => {
//         // small delay to allow Swal to close and layout to stabilise
//         setTimeout(() => {
//           // focus first missing field
//           const first = missing[0];
    
//           if (first.includes("Referral")) {
//             // Focus react-select input by ID (we set inputId="referralSelectInput")
//             const sel = document.getElementById('referralSelectInput');
//             if (sel) {
//               // scroll into view (center) then focus
//               sel.scrollIntoView({ behavior: 'smooth', block: 'center' });
//               sel.focus({ preventScroll: true });
//               return;
//             }
//             // fallback: try to focus by any Select wrapper input
//             const selFallback = document.querySelector('input[id^="react-select"]');
//             if (selFallback) {
//               selFallback.scrollIntoView({ behavior: 'smooth', block: 'center' });
//               selFallback.focus({ preventScroll: true });
//               return;
//             }
//           } else if (first.includes("Patient Name")) {
//             if (patientNameRef?.current) {
//               patientNameRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
//               patientNameRef.current.focus({ preventScroll: true });
//               return;
//             }
//             // fallback selector
//             const el = document.querySelector('input[name="lab_reg_name"]');
//             if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); el.focus({ preventScroll: true }); return; }
//           } else if (first.includes("Age")) {
//             if (ageYearRef?.current) {
//               ageYearRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
//               ageYearRef.current.focus({ preventScroll: true });
//               return;
//             }
//             const el = document.querySelector('input[name="lab_reg_age_year"]');
//             if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); el.focus({ preventScroll: true }); return; }
//           }
    
//           // Final fallback: scroll to top of form
//           const formEl = document.querySelector('form');
//           if (formEl) formEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    
//         }, 150); // 150ms is usually enough; bump to 300ms if needed
//       });
//       return; // stop submission
//     }
    

//     const fd = new FormData();

//     // Create a new array for lab_items that includes the 'lab_item_total' property
//     const itemsWithTotal = formData.tests1.map(item => ({
//         ...item,
//         lab_item_total: item.test_price // Add the missing property here
//     }));

//     // Append all other form data
//     fd.append('lab_reg_id', formData.lab_reg_id);
//     fd.append('lab_reg_name_title', formData.lab_reg_name_title);
//     fd.append('lab_reg_uhid', formData.lab_reg_uhid);
//     fd.append('lab_reg_name', formData.lab_reg_name);
//     fd.append('lab_reg_gender', formData.lab_reg_gender);
//     fd.append('lab_reg_address', formData.lab_reg_address);
//     fd.append('lab_reg_type', formData.lab_reg_type);
//     fd.append('lab_reg_age_year', formData.lab_reg_age_year);
//     fd.append('lab_reg_age_month', formData.lab_reg_age_month);
//     fd.append('lab_reg_age_day', formData.lab_reg_age_day);
//     fd.append('lab_reg_city', formData.lab_reg_city);
//     fd.append('lab_reg_state', formData.lab_reg_state);
//     fd.append('lab_reg_mobile', formData.lab_reg_mobile);
//     fd.append('lab_reg_referral', formData.lab_reg_referral);
//     fd.append('lab_reg_sample', formData.lab_reg_sample);
//     fd.append('lab_reg_date', formData.lab_reg_date);
//     fd.append('lab_guardian_title', formData.lab_guardian_title);
//     fd.append('lab_guardian_name', formData.lab_guardian_name);
//     fd.append('lab_collected_at', formData.lab_collected_at);
//     fd.append('lab_total', formData.lab_total);
//     fd.append('lab_dis_per', formData.lab_dis_per);
//     fd.append('lab_fix_deposit', formData.lab_fix_deposit);
//     fd.append('lab_final_amt', formData.lab_final_amt);
//     fd.append('lab_paid', formData.lab_paid);
//     fd.append('lab_due', formData.lab_due);
//     fd.append('lab_pay_mode', formData.lab_pay_mode);
//     fd.append('lab_remarks', formData.lab_remarks);
    
//     // **FIX**: Stringify the new array that includes the total
//     fd.append('lab_items', JSON.stringify(itemsWithTotal)); 
    
//     fd.append('lab_reg_user', ldata.user_id);
//     fd.append('broker_id', brokerId || '');
//     fd.append('broker_name', brokerLabel || '');
    
//     try {
//         const response = await axios.post(AppConst.BASE_URL + AppConst.addLabRegUrl, fd, {
//             headers: {
//                 'Content-Type': 'multipart/form-data',
//             },
//         });
//  console.log("res : " + JSON.stringify(response))

//             if (response.data.status) {
//                 setFormData(prev => ({
//                     ...prev,
//                     lab_reg_uhid: response.data.lab_reg_dt.lab_reg_uhid,
//                     lab_reg_id: response.data.lab_reg_dt.lab_reg_id,
//                     isAlert: true,
//                     alertMsg: response.data.success,
//                     alertMsgTyp: response.data.type,
//                 }));
//                 // window.location.href = "/lab_patient_list";
//                  toast.success("Registered successfully");
//                  setIsSaved(true)
//             }
//             else {
//                 setFormData(prev => ({
//                     ...prev,
//                     isAlert: true,
//                     alertMsg: response.data.success,
//                     alertMsgTyp: response.data.type,
//                 }));
//             }
//         } catch (error) {
//             setFormData(prev => ({
//                 ...prev,
//                 isAlert: true,
//                 alertMsg: "Failed",
//                 alertMsgTyp: "danger",
//             }));
//         }

//     };



// useEffect(() => {
//   const key = formData.search_key;
//   // key ko trim karke check karo, agar empty hai, par original me " " hai to search chalu karo
//   if ((key.trim().length === 0 && key.length > 0) || key.length === 0) {
//     // Agar only spaces hain (key length > 0 but trim empty) toh search mat karo
//     setSearchResults([]);
//     return;
//   }

  // Baaki search code yahan chalu kar do...
// }, [formData.search_key]);
const handleSubmit = async (e) => {
  e.preventDefault();

  // ============================================
  // STEP 1: VALIDATION
  // ============================================
  const missing = [];

  // Validate referral doctor
  if (!referralId || String(referralId).trim() === "") {
    missing.push("Referral Doctor (select from list)");
  }

  // Validate patient name
  if (!formData.lab_reg_name || String(formData.lab_reg_name).trim() === "") {
    missing.push("Patient Name");
  }

  // Validate age - allow 0 as valid (newborn/unknown age)
  const ageYears = formData.lab_reg_age_year;
  if (ageYears === '' || ageYears === null || ageYears === undefined) {
    missing.push("Age (Years)");
  }

  // Validate mobile number
  if (!formData.lab_reg_mobile || String(formData.lab_reg_mobile).trim() === "") {
    missing.push("Mobile Number");
  }

  // Validate at least one test
  if (!formData.tests1 || formData.tests1.length === 0) {
    missing.push("At least one test (select tests)");
  }

  console.log("[Lab] missing fields:", missing);

  // Show validation errors if any
  if (missing.length > 0) {
    const listHtml = missing.map(m => `<li>${m}</li>`).join("");
    Swal.fire({
      icon: "warning",
      title: "Missing Required Fields",
      html: `<p>Please complete the following before submitting:</p><ul style="text-align:left">${listHtml}</ul>`,
      confirmButtonText: "OK",
      confirmButtonColor: "#3085d6"
    }).then(() => {
      // Focus on first missing field after alert closes
      setTimeout(() => {
        const first = missing[0];
  
        if (first.includes("Referral")) {
          const sel = document.getElementById('referralSelectInput');
          if (sel) {
            sel.scrollIntoView({ behavior: 'smooth', block: 'center' });
            sel.focus({ preventScroll: true });
            return;
          }
          const selFallback = document.querySelector('input[id^="react-select"]');
          if (selFallback) {
            selFallback.scrollIntoView({ behavior: 'smooth', block: 'center' });
            selFallback.focus({ preventScroll: true });
            return;
          }
        } else if (first.includes("Patient Name")) {
          if (patientNameRef?.current) {
            patientNameRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            patientNameRef.current.focus({ preventScroll: true });
            return;
          }
          const el = document.querySelector('input[name="lab_reg_name"]');
          if (el) { 
            el.scrollIntoView({ behavior: 'smooth', block: 'center' }); 
            el.focus({ preventScroll: true }); 
            return; 
          }
        } else if (first.includes("Age")) {
          if (ageYearRef?.current) {
            ageYearRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            ageYearRef.current.focus({ preventScroll: true });
            return;
          }
          const el = document.querySelector('input[name="lab_reg_age_year"]');
          if (el) { 
            el.scrollIntoView({ behavior: 'smooth', block: 'center' }); 
            el.focus({ preventScroll: true }); 
            return; 
          }
        } else if (first.includes("Mobile")) {
          const el = document.querySelector('input[name="lab_reg_mobile"]');
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            el.focus({ preventScroll: true });
            return;
          }
        } else if (first.includes("test")) {
          const el = document.querySelector('input[name="search_key"]');
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            el.focus({ preventScroll: true });
            return;
          }
        }
  
        // Final fallback: scroll to top of form
        const formEl = document.querySelector('form');
        if (formEl) formEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  
      }, 150);
    });
    return; // Stop submission
  }

  // ============================================
  // STEP 2: PREPARE FORM DATA
  // ============================================
  
  // Create items array with proper structure
  const itemsWithTotal = formData.tests1.map(item => ({
      test_id: item.test_id || '',
      test_name: item.test_name || '',
      test_price: parseFloat(item.test_price || 0),
      test_discount: parseFloat(item.test_discount || 0),
      lab_item_total: parseFloat(item.lab_item_total || item.test_price || 0)
  }));

  // Prepare FormData
  const fd = new FormData();

  // Lab registration basic info
  fd.append('lab_reg_id', formData.lab_reg_id || '');
  fd.append('lab_reg_name_title', formData.lab_reg_name_title || 'Mr.');
  fd.append('lab_reg_uhid', formData.lab_reg_uhid || '');
  fd.append('lab_reg_name', formData.lab_reg_name || '');
  fd.append('lab_reg_gender', formData.lab_reg_gender || 'Male');
  fd.append('lab_reg_address', formData.lab_reg_address || '');
  fd.append('lab_reg_type', formData.lab_reg_type || 'Direct');
  
  // Age fields
  fd.append('lab_reg_age_year', formData.lab_reg_age_year || '0');
  fd.append('lab_reg_age_month', formData.lab_reg_age_month || '0');
  fd.append('lab_reg_age_day', formData.lab_reg_age_day || '0');
  
  // Contact and location
  fd.append('lab_reg_city', formData.lab_reg_city || '');
  fd.append('lab_reg_state', formData.lab_reg_state || '');
  fd.append('lab_reg_mobile', formData.lab_reg_mobile || '');
  
  // Referral and sample
  fd.append('lab_reg_referral', formData.lab_reg_referral || '');
  fd.append('lab_reg_sample', formData.lab_reg_sample || '');
  fd.append('lab_reg_date', formData.lab_reg_date || '');
  
  // Guardian info
  fd.append('lab_guardian_title', formData.lab_guardian_title || '');
  fd.append('lab_guardian_name', formData.lab_guardian_name || '');
  
  // Collection info
  fd.append('lab_collected_at', formData.lab_collected_at || '');
  
  // Financial details
  fd.append('lab_total', formData.lab_total || '0');
  fd.append('lab_dis_per', formData.lab_dis_per || '0');
  fd.append('lab_fix_deposit', formData.lab_fix_deposit || '0');
  fd.append('lab_final_amt', formData.lab_final_amt || '0');
  fd.append('lab_paid', formData.lab_paid || '0');
  fd.append('lab_due', formData.lab_due || '0');
  fd.append('lab_pay_mode', formData.lab_pay_mode || 'Cash');
  
  // Remarks
  fd.append('lab_remarks', formData.lab_remarks || '');
  
  // Stringify the items array
  fd.append('lab_items', JSON.stringify(itemsWithTotal)); 
  
  // User and broker data
  fd.append('lab_reg_user', ldata?.user_id || '1');
  fd.append('broker_id', brokerId || '');
  fd.append('broker_name', brokerLabel || '');
  
  // ============================================
  // STEP 3: SUBMIT TO SERVER
  // ============================================
  
  try {
      // Show loading indicator
      // const loadingToast = toast.loading("Saving registration...", {
      //     position: "top-center",
      //     autoClose: false,
      // });

      // console.log("[Lab] Submitting registration data...");

      // Make API call
      const response = await axios.post(
          AppConst.BASE_URL + AppConst.addLabRegUrl, 
          fd, 
          {
              headers: {
                  'Content-Type': 'multipart/form-data',
              },
              timeout: 30000, // 30 seconds timeout
          }
      );

      // Dismiss loading toast
      // toast.dismiss(loadingToast);

      // console.log("[Lab] Server response:", JSON.stringify(response.data, null, 2));

      // ============================================
      // STEP 4: HANDLE SUCCESS RESPONSE
      // ============================================
      
      if (response.data.status) {
          // Update form data with saved registration details
          setFormData(prev => ({
              ...prev,
              lab_reg_uhid: response.data.lab_reg_dt?.lab_reg_uhid || prev.lab_reg_uhid,
              lab_reg_id: response.data.lab_reg_dt?.lab_reg_id || prev.lab_reg_id,
              isAlert: true,
              alertMsg: response.data.success || "Saved successfully",
              alertMsgTyp: response.data.type || "success",
          }));
          
          // Show main success message
          toast.success(response.data.success || "Registration saved successfully!", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
          });
          
          // Mark as saved
          setIsSaved(true);
          
          // ============================================
          // STEP 5: HANDLE WHATSAPP NOTIFICATION STATUS
          // ============================================
          
          // ============================================
// STEP 5: HANDLE WHATSAPP NOTIFICATION STATUS
// ============================================

if (response.data.whatsapp_status) {
    
  if (response.data.whatsapp_status === 'sent') {
      // WhatsApp sent successfully
      let whatsappMessage = "✅ WhatsApp notification sent successfully";
      
      // Check if PDF was also sent
      if (response.data.pdf_sent) {
          whatsappMessage += " with PDF bill";
      }
      
      toast.success(whatsappMessage, {
          position: "top-right",
          autoClose: 6000,
          // ... styling
      });
      
  } else if (response.data.whatsapp_status === 'failed') {
      // WhatsApp failed
      toast.warning(
          `⚠️ Registration saved but WhatsApp failed: ${response.data.whatsapp_message}`,
          // ... options
      );
      
  } else if (response.data.whatsapp_status === 'error') {
      // WhatsApp error
      toast.error(
          `❌ Registration saved but WhatsApp error: ${response.data.whatsapp_message}`,
          // ... options
      );
  }
}
          
          // ============================================
          // STEP 6: POST-SAVE ACTIONS (OPTIONAL)
          // ============================================
          
          // Optional: Auto-redirect after successful save
          // setTimeout(() => {
          //     window.location.href = "/lab_patient_list";
          // }, 2000);
          
      } else {
          // ============================================
          // HANDLE FAILURE RESPONSE
          // ============================================
          
          setFormData(prev => ({
              ...prev,
              isAlert: true,
              alertMsg: response.data.success || "Failed to save",
              alertMsgTyp: response.data.type || "danger",
          }));
          
          toast.error(response.data.success || "Failed to save registration", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
          });
          
          console.error("[Lab] Save failed:", response.data);
      }
      
  } catch (error) {
      // ============================================
      // HANDLE ERRORS
      // ============================================
      
      console.error("[Lab] Submit error:", error);
      
      // Determine error message based on error type
      let errorMessage = "Failed to save registration";
      let errorDetails = "";
      
      if (error.response) {
          // Server responded with error status
          errorMessage = error.response.data?.success || 
                        error.response.data?.message || 
                        `Server error: ${error.response.status}`;
          errorDetails = JSON.stringify(error.response.data);
          
          console.error("[Lab] Server error:", error.response.status, error.response.data);
          
      } else if (error.request) {
          // Request made but no response received
          errorMessage = "No response from server. Please check your internet connection.";
          errorDetails = "Network error - no response received";
          
          console.error("[Lab] Network error - no response:", error.request);
          
      } else if (error.code === 'ECONNABORTED') {
          // Request timeout
          errorMessage = "Request timeout. The server is taking too long to respond.";
          errorDetails = "Connection timeout";
          
          console.error("[Lab] Request timeout:", error.message);
          
      } else {
          // Something else happened
          errorMessage = error.message || "An unexpected error occurred";
          errorDetails = error.toString();
          
          console.error("[Lab] Unexpected error:", error);
      }
      
      // Update form state
      setFormData(prev => ({
          ...prev,
          isAlert: true,
          alertMsg: errorMessage,
          alertMsgTyp: "danger",
      }));
      
      // Show error toast
      toast.error(errorMessage, {
          position: "top-right",
          autoClose: 7000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
      });
      
      // Log full error details
      console.error("[Lab] Full error details:", errorDetails);
      
      // Optional: Show detailed error in development mode
      if (process.env.NODE_ENV === 'development') {
          console.error("[Lab] Error stack:", error.stack);
      }
  }
};
const loadBrokers = async (search = '') => {
  try {
    setLoadingBrokers(true);
    const fd = new FormData();
    fd.append('search_key', search || '');
    fd.append('page_no', 'none');
    const res = await axios.post(AppConst.BASE_URL + AppConst.getBrokerListUrl, fd, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    const records = (res?.data?.records && Array.isArray(res.data.records)) ? res.data.records : [];
    
    // Map rows to react-select options
    const opts = records.map(r => ({
      value: String(r.broker_id ?? r.id ?? r.user_id ?? ''),
      label: `${(r.fname||'').trim()}${r.lname ? ' ' + (r.lname||'').trim() : ''}`.trim() || (r.mobile||'Unknown'),
      raw: r
    }));

    // IMPORTANT: Preserve current selection if it exists and isn't in the new results
    setBrokerOptions(prev => {
      // Get current brokerId from closure or check if there's a selected option
      const currentBrokerId = brokerId; // This captures current brokerId
      const currentBrokerLabel = brokerLabel;
      
      if (currentBrokerId) {
        const existsInNew = opts.find(o => String(o.value) === String(currentBrokerId));
        if (!existsInNew) {
          // Prepend current selection to new options
          return [
            { value: String(currentBrokerId), label: currentBrokerLabel || String(currentBrokerId), raw: null },
            ...opts
          ];
        }
      }
      return opts;
    });
  } catch (err) {
    console.error('loadBrokers', err);
    setBrokerOptions([]);
  } finally {
    setLoadingBrokers(false);
  }
};

useEffect(() => {
  // Wait a tick to allow session data to load first
  const timer = setTimeout(() => {
    loadBrokers('');
  }, 200);
  return () => clearTimeout(timer);
}, []);
// Replace this useEffect:
// Fix: Ensure broker option is added when brokerId/brokerLabel are set from session
useEffect(() => {
  if (!brokerId) return;
  
  // Use functional update to ensure we're working with latest state
  setBrokerOptions(prev => {
    // Check if already exists in current options
    const found = prev.find(opt => String(opt.value) === String(brokerId));
    if (found) {
      // Update the label if it's different (in case we only had ID before)
      if (brokerLabel && found.label !== brokerLabel) {
        return prev.map(opt => 
          String(opt.value) === String(brokerId) 
            ? { ...opt, label: brokerLabel }
            : opt
        );
      }
      return prev; // no change needed
    }
    
    // Prepend the broker option
    return [
      { value: String(brokerId), label: brokerLabel || String(brokerId), raw: null },
      ...prev
    ];
  });
}, [brokerId, brokerLabel]);


    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
 const storedDataF = JSON.parse(sessionStorage.getItem("ldata") || "{}");
// console.log("session data :", storedDataF);

setName(
  [storedDataF?.fname, storedDataF?.lname].filter(Boolean).join(" ")
);



        if (storedData) {
            const parsed = JSON.parse(storedData);

            const fd1 = new FormData();
            fd1.append('profile_hosp_user', 1);
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getProfileUrl1, fd1, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });

               
                if (response.data.status) {

                    var user_dt = response.data.user_dt;
                    if (user_dt != null && user_dt != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            lab_collected_at: user_dt.profile_hosp_name
                        }));
                    }
                }
            } catch (error) {

            }

            const fd2 = new FormData();
            fd2.append('type', "doctor");
            fd2.append('search_key', " ");
            fd2.append('page_no', "none");
            fd2.append('user_cre_by', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd2, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {

                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            docs: records
                        }));
                    }
                }
            } catch (error) {

            }
        }
    };

    // --- SINGLE robust loader for sessionStorage.lab_dt ---







    // useEffect(() => {
    //     if (formData.lab_total.length > 0) {
    //         var gtotal = parseFloat(formData.lab_total);
    //         setFormData(prev => ({
    //             ...prev,
    //             lab_final_amt: gtotal + ""
    //         }));
    //         if (formData.lab_dis_per.length > 0) {
    //             var dis = parseFloat(formData.lab_dis_per);
    //             gtotal = gtotal - ((gtotal * dis) / 100);
    //             setFormData(prev => ({
    //                 ...prev,
    //                 lab_final_amt: gtotal + ""
    //             }));
    //         }

    //         if (formData.lab_fix_deposit.length > 0) {
    //             var fix_dep = parseFloat(formData.lab_fix_deposit);
    //             gtotal = gtotal - fix_dep;
    //             setFormData(prev => ({
    //                 ...prev,
    //                 lab_final_amt: gtotal + ""
    //             }));
    //         }

    //         if (formData.lab_paid.length > 0) {
    //             var paid = parseFloat(formData.lab_paid);
    //             var due = gtotal - paid;
    //             setFormData(prev => ({
    //                 ...prev,
    //                 lab_due: due + ""
    //             }));
    //         }

    //     }

    // }, [formData.lab_total, formData.lab_dis_per, formData.lab_paid, formData.lab_fix_deposit]);
    useEffect(() => {
      // Parse numbers safely (empty string allowed)
      const total = parseFloat(formData.lab_total || "0") || 0;
      const disPer = parseFloat(formData.lab_dis_per || "0") || 0;
      const fixDep = parseFloat(formData.lab_fix_deposit || "0") || 0;
      const paid = formData.lab_paid === "" ? 0 : (parseFloat(formData.lab_paid || "0") || 0);
    
      // Compute final in single step
      let computedFinal = total;
    
      // apply percent discount if present
      if (disPer > 0) {
        computedFinal = computedFinal - (computedFinal * disPer) / 100;
      }
      // apply fixed deposit
      if (fixDep > 0) {
        computedFinal = computedFinal - fixDep;
      }
    
      // ensure not negative
      if (computedFinal < 0) computedFinal = 0;
    
      // compute due (if user cleared paid input we treat paid as 0)
      let computedDue = computedFinal - paid;
      if (computedDue < 0) computedDue = 0;
    
      // Update state in one setFormData call to avoid cascading updates
      setFormData((prev) => ({
        ...prev,
        lab_final_amt: computedFinal.toFixed(2),
        lab_due: computedDue.toFixed(2),
        // do NOT overwrite lab_paid here — preserve user typed value (including empty string)
      }));
    }, [formData.lab_total, formData.lab_dis_per, formData.lab_fix_deposit, formData.lab_paid]);
    

  //         function getDoctorNameById(id) {
  // const doctor = formData.docs.find(doc => doc.user_id === String(id));
  // return doctor ? doctor.fname : "Doctor not found";
  //     }



  function getDoctorNameById(id) {
    if (id === null || id === undefined || id === "") return "Doctor not found";
    const idStr = String(id).trim();
    const doctor = (formData.docs || []).find(doc => {
      // support both user_id or id property names
      const docId = doc?.user_id ?? doc?.id ?? "";
      return String(docId).trim() === idStr;
    });
    if (!doctor) return "Doctor not found";
    // prefer full name if available
    const fullName = [doctor.fname, doctor.lname].filter(Boolean).join(" ");
    return fullName || doctor.fname || "Doctor";
  }
  
  const searchUserNow = async () => {
    const uhid = (formData.lab_reg_uhid || "").trim();
  
    // UHID validation
    if (uhid.length <= 7) {
      toast.error("Please enter a valid UHID");
      return;
    }
  
    try {
      const fd = new FormData();
      fd.append('lab_reg_uhid', uhid);
  
      const response = await axios.post(
        AppConst.BASE_URL + AppConst.searchUhidUrlCall,
        fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
  
      console.log("REEEEEE : " + JSON.stringify(response.data));
  
      if (!response.data.status) {
        toast.error(response.data.message || "No patient found");
        return;
      }
  
      const users = response.data.records;
      if (!users || users.length === 0) {
        toast.error("No patient found with this UHID");
        return;
      }
  
      // use the first matched patient
      const patient = users[0];
  
      // derive referral id candidates (works for IPD/OPD payloads)
      const referralId = patient.lab_reg_referral
                       || patient.ipd_refer_doctor
                       || patient.refer_doctor
                       || "";
  
      // Map referral id -> name using local docs cache
      const referralName = getDoctorNameById(referralId);
      const referralForForm = (referralName && referralName !== "Doctor not found")
                              ? referralName
                              : referralId; // fallback to id (so UI shows something)
  
      // Set patient into form — use referralForForm (name when possible)
      setFormData(prev => ({
        ...prev,
        lab_reg_name_title: patient.lab_reg_name_title || "Mr.",
        lab_reg_name: patient.lab_reg_name || "",
        lab_reg_gender: patient.lab_reg_gender || "male",
        lab_reg_address: patient.lab_reg_address || "",
        lab_reg_city: patient.lab_reg_city || "",
        lab_reg_mobile: patient.lab_reg_mobile || "",
        lab_reg_type: patient.lab_reg_type || "",
        lab_reg_age_year: patient.lab_reg_age_year || '',
        lab_reg_age_month: patient.lab_reg_age_month || '',
        lab_reg_age_day: patient.lab_reg_age_day || '',
        lab_reg_state: patient.lab_reg_state || "",
        lab_reg_uhid: patient.lab_reg_uhid || "",
        lab_reg_referral: referralForForm,
        lab_guardian_name: patient.lab_guardian_name || '',
      }));
  
      toast.success("Patient details loaded");
    } catch (error) {
      console.error("Search Error:", error);
      toast.error("Error fetching patient details");
    }
  };
  



      const handleAddDepart = () => {
    formData.page_no = 0;
    initData();
  };
    // useEffect(() => {
    //     if (formData.search_key.length > 0) {
    //         document.getElementById("poptst45").click();
    //     }
    // }, [formData.search_key]);
    const handleSelUser = (lab_reg_dt) => {
        if (lab_reg_dt != null && lab_reg_dt != undefined) {
            setFormData(prev => ({
                ...prev,
                lab_reg_id: lab_reg_dt.lab_reg_id,
                lab_reg_uhid: lab_reg_dt.lab_reg_uhid,
                lab_reg_name_title: lab_reg_dt.lab_reg_name_title,
                lab_reg_name: lab_reg_dt.lab_reg_name,
                lab_reg_gender: lab_reg_dt.lab_reg_gender,
                lab_reg_address: lab_reg_dt.lab_reg_address,
                lab_reg_type: lab_reg_dt.lab_reg_type,
                lab_reg_age_year: lab_reg_dt.lab_reg_age_year,
                lab_reg_age_month: lab_reg_dt.lab_reg_age_month,
                lab_reg_age_day: lab_reg_dt.lab_reg_age_day,
                lab_reg_city: lab_reg_dt.lab_reg_city,
                lab_reg_state: lab_reg_dt.lab_reg_state,
                lab_reg_mobile: lab_reg_dt.lab_reg_mobile,
                lab_reg_referral: lab_reg_dt.lab_reg_referral,
                lab_reg_sample: lab_reg_dt.lab_reg_sample,
                lab_reg_date: lab_reg_dt.lab_reg_date,
                lab_guardian_title: lab_reg_dt.lab_guardian_title,
                lab_guardian_name: lab_reg_dt.lab_guardian_name,
                lab_collected_at: lab_reg_dt.lab_collected_at,
               
            }));
            setBrokerId(String(lab_reg_dt.lab_reg_broker_id ?? lab_reg_dt.brokerId ?? ''));
            setBrokerLabel(String(lab_reg_dt.lab_reg_broker_name ?? lab_reg_dt.broker_name ?? lab_reg_dt.brokerName ?? ''));
        }
    }

    const handleAutoGenderChange = (e) => {
      const { name, value } = e.target;
    
      let genderValue = "Other";
      if (value === "Mr." || value === "Master" || value === "Mr's") {
        genderValue = "Male";
      } else if (value === "Miss") {
        genderValue = "Female";
      }
    
      // set the title field by name (so it matches handleChange style)
      setFormData((prev) => ({
        ...prev,
        [name]: value,           // sets lab_reg_name_title
        lab_reg_gender: genderValue
      }));
    };
    
    useEffect(() => {
      console.debug("[Registrations] Session loader starting");
    
      if (sessionLoadedRef.current) {
        console.debug("[Registrations] Already loaded session data, skipping");
        return;
      }
    
      const formattedToday = getLocalDateYYYYMMDD();
      setFormData(prev => ({ ...prev, lab_reg_date: formattedToday }));
    
      // Initialize ldata
      const storedLdata = sessionStorage.getItem("ldata");
      if (storedLdata) {
        try {
          const parsed = JSON.parse(storedLdata);
          setLdata(parsed);
          initData();
        } catch (err) {
          console.warn("[Registrations] failed parsing ldata:", err);
        }
      }
    
      // Try both lab_dt and lab_prefill keys
      const raw = sessionStorage.getItem("lab_dt") || sessionStorage.getItem("lab_prefill");
      
      if (!raw) {
        console.debug("[Registrations] No session data found - new registration mode");
        setIsUHIDReadOnly(false);
        sessionLoadedRef.current = true;
        return;
      }
    
      let tmp;
      try {
        tmp = JSON.parse(raw);
      } catch (err) {
        console.error("[Registrations] Failed to parse session data:", err);
        setIsUHIDReadOnly(false);
        sessionLoadedRef.current = true;
        return;
      }
    
      if (!tmp || typeof tmp !== "object") {
        console.warn("[Registrations] Invalid session data:", tmp);
        setIsUHIDReadOnly(false);
        sessionLoadedRef.current = true;
        return;
      }
    
      console.debug("[Registrations] Loading session data:", tmp);
    
      // Find tests array
      const sourceTests = Array.isArray(tmp.params)
        ? tmp.params
        : (Array.isArray(tmp.all_tests) ? tmp.all_tests : (Array.isArray(tmp.tests) ? tmp.tests : (Array.isArray(tmp.tests1) ? tmp.tests1 : [])));
    
      const transformedTests = transformTestData(sourceTests || []);
      const autoTotal = transformedTests.reduce((s, t) => s + Number(t.lab_item_total ?? t.test_price ?? 0), 0);
    
      // Update form data
      setFormData(prev => ({
        ...prev,
        tests1: transformedTests,
        lab_reg_id: tmp.lab_reg_id ?? "",
        lab_reg_uhid: tmp.lab_reg_uhid ?? prev.lab_reg_uhid,
        lab_reg_name_title: tmp.lab_reg_name_title ?? prev.lab_reg_name_title,
        lab_reg_name: tmp.lab_reg_name ?? prev.lab_reg_name,
        lab_reg_gender: tmp.lab_reg_gender ?? prev.lab_reg_gender,
        lab_reg_address: tmp.lab_reg_address ?? prev.lab_reg_address,
        lab_reg_type: tmp.lab_reg_type ?? prev.lab_reg_type,
        lab_reg_age_year: tmp.lab_reg_age_year ?? prev.lab_reg_age_year,
        lab_reg_age_month: tmp.lab_reg_age_month ?? prev.lab_reg_age_month,
        lab_reg_age_day: tmp.lab_reg_age_day ?? prev.lab_reg_age_day,
        lab_reg_city: tmp.lab_reg_city ?? prev.lab_reg_city,
        lab_reg_state: tmp.lab_reg_state ?? prev.lab_reg_state,
        lab_reg_mobile: tmp.lab_reg_mobile ?? prev.lab_reg_mobile,
        lab_reg_referral: tmp.lab_reg_referral ?? prev.lab_reg_referral,
        lab_reg_sample: tmp.lab_reg_sample ?? prev.lab_reg_sample,
        lab_reg_date: normalizeToLocalYYYYMMDD(tmp.lab_reg_date || formattedToday),
        lab_guardian_title: tmp.lab_guardian_title ?? prev.lab_guardian_title,
        lab_guardian_name: tmp.lab_guardian_name ?? prev.lab_guardian_name,
        lab_collected_at: tmp.lab_collected_at ?? prev.lab_collected_at,
        lab_total: (tmp.lab_total ?? autoTotal).toString(),
        lab_dis_per: tmp.lab_dis_per ?? prev.lab_dis_per,
        lab_fix_deposit: tmp.lab_fix_deposit ?? prev.lab_fix_deposit,
        lab_final_amt: tmp.lab_final_amt ?? prev.lab_final_amt,
        lab_paid: tmp.lab_paid ?? prev.lab_paid,
        lab_due: tmp.lab_due ?? prev.lab_due,
        lab_pay_mode: tmp.lab_pay_mode ?? prev.lab_pay_mode,
        lab_remarks: tmp.lab_remarks ?? prev.lab_remarks,
        lab_reg_user: tmp.lab_reg_user ?? prev.lab_reg_user,
      }));
    
      // Set broker
      setBrokerId(String(tmp.lab_reg_broker_id ?? tmp.brokerId ?? ''));
      setBrokerLabel(String(tmp.lab_reg_broker_name ?? tmp.broker_name ?? tmp.brokerName ?? ''));
      setTimeout(() => loadBrokers(''), 100);
    
      // Set referral (will be resolved once doctors load)
      setPendingReferralToResolve(tmp.lab_reg_referral ?? tmp.lab_reg_referral_id ?? "");
    
      // Lock UHID if this is an existing patient
      setOriginalLabRegType(tmp.lab_reg_type ?? "");
      setIsUHIDReadOnly(Boolean(tmp.lab_reg_uhid));
    
      sessionLoadedRef.current = true;
      console.debug("[Registrations] Session data loaded successfully");
    
      // Clean up session storage after loading
      return () => {
        try {
          sessionStorage.removeItem("lab_prefill");
          sessionStorage.removeItem("lab_dt");
        } catch (e) {
          console.warn("Cleanup error:", e);
        }
      };
    }, []);
        
    const transformTestData = (tests = []) => {
      return (tests || []).map(test => {
        const raw = test || {};
    
        // Prefer server lab_item_* names, fallback to generic names
        const testId = raw.lab_item_test_id ?? raw.test_id ?? raw.lab_item_id ?? raw.id ?? "";
        const testName = String(raw.lab_item_test_name ?? raw.test_name ?? raw.name ?? "").trim();
        const priceRaw = raw.lab_item_test_price ?? raw.test_price ?? raw.test_rate ?? raw.price ?? 0;
        const price = Number(priceRaw || 0);
    
        // prefer explicit per-test total if present (server may send lab_item_total)
        const labItemTotal = Number(raw.lab_item_total ?? raw.lab_item_test_price ?? price);
    
        const testDiscount = Number(raw.lab_item_dis_per ?? raw.test_discount ?? raw.test_item_discount ?? 0);
    
        return {
          // canonical keys your UI and logic expect
          test_id: String(testId),
          test_name: testName,
          test_price: price,
          lab_item_total: labItemTotal,
          test_discount: testDiscount,
    
          // keep raw server fields in case you need them
          _raw: raw,
          lab_item_test_id: raw.lab_item_test_id,
          lab_item_test_name: raw.lab_item_test_name,
          lab_item_test_price: raw.lab_item_test_price,
          lab_item_id: raw.lab_item_id,
        };
      });
    };
    
    
    




    useEffect(() => {
      const delayDebounceFn = setTimeout(() => {
        const key = (formData.search_key ?? "").trim();
        if (key.length > 0) {
          // typed search
          fetchTests(key);
          setShowSearchDropdown(true);
        } else {
          // empty input: load default (first page / popular tests) so dropdown still shows
          fetchTests("");     // make sure your API returns a sensible default for empty search_key
          // keep dropdown open when field is focused; effect runs on value change only
        }
      }, 300);
    
      return () => clearTimeout(delayDebounceFn);
    }, [formData.search_key]);
    
    
 
 
    const handleSelTst = (selectedTest) => {
      if (!selectedTest) return;
    
      // Normalize incoming test (selectedTest may come from search API or from server)
      const normalized = transformTestData([selectedTest])[0];
    
      // Get the ID and name from the selected test - be flexible with property names
      const selId = String(
        normalized.test_id || 
        normalized.lab_item_test_id || 
        normalized.id || 
        selectedTest.test_id || 
        selectedTest.id || 
        ""
      ).trim().toLowerCase();
      
      const selName = String(
        normalized.test_name || 
        normalized.lab_item_test_name || 
        selectedTest.test_name || 
        selectedTest.name || 
        ""
      ).trim().toLowerCase();
    
      // Check if test already exists - be more flexible with comparisons
      const isAlreadyAdded = formData.tests1.some(test => {
        // Get all possible ID variations from existing test
        const tId = String(
          test.test_id ?? 
          test.lab_item_test_id ?? 
          test.id ?? 
          test._raw?.test_id ?? 
          test._raw?.lab_item_test_id ?? 
          test._raw?.id ?? 
          ""
        ).trim().toLowerCase();
        
        // Get all possible name variations from existing test
        const tName = String(
          test.test_name ?? 
          test.lab_item_test_name ?? 
          test.name ?? 
          test._raw?.test_name ?? 
          test._raw?.lab_item_test_name ?? 
          test._raw?.name ?? 
          ""
        ).trim().toLowerCase();
    
        // Match by ID (preferred) or by name (fallback)
        const idMatch = (selId && tId && selId === tId);
        const nameMatch = (selName && tName && selName === tName);
        
        return idMatch || nameMatch;
      });
    
      if (isAlreadyAdded) {
        toast.error("Test Already Added");
        return;
      }
    
      const updatedTests = [...formData.tests1, normalized];
    
      const total = updatedTests.reduce(
        (sum, test) => sum + Number(test.lab_item_total ?? test.test_price ?? 0),
        0
      );
    
      setFormData(prev => ({
        ...prev,
        tests1: updatedTests,
        lab_total: total.toFixed(2)
      }));
      
      // Success feedback
      //toast.success(`${selName || 'Test'} added successfully`);
    };
    
    


  const fetchConfigData = async () => {
    try {
      const res = await axios.post(
        `${AppConst.BASE_URL + AppConst.getconfig}?config_type=lab`
      );

      if (res.data.status) {
        const data = res.data;
// console.log("Config Data:", JSON.stringify(data.header_logo));
        setImage(data.header_logo);
   
    } 
}
    catch (err) {
      console.error("Error fetching config:", err);
    }
  };

  useEffect(() => {
    fetchConfigData()
  });
 

  // Function to convert an image URL to a Base64 string
const imageUrlToBase64 = async (url) => {
  // Check if the URL is valid in the first place
  if (!url) {
    console.error("Image URL is empty or invalid.");
    return null;
  }

  try {
    const response = await fetch(url);
    if (!response.ok) {
        console.error(`Failed to fetch image. Status: ${response.status} ${response.statusText}`);
        return null;
    }
    
    const blob = await response.blob();

    // **IMPORTANT CHECK**: This ensures the downloaded file is an image.
    if (!blob.type.startsWith('image/')) {
      console.error(`The provided URL did not point to an image. It pointed to a file of type: ${blob.type}`);
      return null;
    }

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error("Error fetching or converting image:", error);
    return null;
  }
};

    // console.log("Search Results:", JSON.stringify(formData));
const generatePDF = async (headerOption) => {
  const doc = new jsPDF();

  // define header image height (in points). Reduce this to move content up below header.
  let imgHeight = 26; // try 20..28 to tune
  let startYOffset = 3; // extra gap after header. Decrease to move table up.

  if (headerOption === 'with') {
    const imageUrl = image;
    const headerImageBase64 = await imageUrlToBase64(imageUrl);

    if (headerImageBase64) {
      const pageWidth = doc.internal.pageSize.getWidth();
      // Draw header image at top with height imgHeight
      doc.addImage(headerImageBase64, 0, 0, pageWidth, imgHeight);
    } else {
      // if header missing still keep a small top margin
      imgHeight = 0;
    }
  } else {
    // no header
    imgHeight = 0;
    startYOffset = 6; // little top space when no header
  }

  // compute startY from header height and small offset
  // reduce startYOffset if you want it closer to header
  let y = imgHeight + startYOffset;

  // If you want the patient-details table even higher, subtract a few points:
  // y -= 6; // uncomment to move up 6 points

  autoTable(doc, {
    startY: y,
    body: [[
      `UHID No : ${formData.lab_reg_uhid || ''}\n` +
      `Reg No : 00${formData.lab_reg_id || ''}\n` +
      `Patient Name: ${formData.lab_reg_name_title || ''} ${formData.lab_reg_name || ''}\n` +
      `Registered Date : ${formatDate(formData.lab_reg_date)}`,
      `Address : ${formData.lab_reg_address || ''}\n` +
      `Mobile No : ${formData.lab_reg_mobile || ''}`,
     `Age : ${getAgeDisplay(formData)}\n` +
      `Gender : ${formData.lab_reg_gender || ''}\n` +
      `Referred Doctor : ${formData.lab_reg_referral || ''}`
    ]],
    theme: 'grid',
    styles: { fontSize: 8, cellPadding: 2, valign: 'top', textColor: [0,0,0], lineColor: [0,0,0], lineWidth: 0.1 },
    margin: { left: 10, right: 10 },
    tableWidth: 'auto',
    columnStyles: { 0: { cellWidth: 60 }, 1: { cellWidth: 60 }, 2: { cellWidth: 70 } }
  });


y = doc.lastAutoTable.finalY + 1;
//doc.line(10, y, 200, y); // horizontal line full width
y += 1;

// ==== Tests Table ====
const testData = Array.from(
  new Map(formData.tests1.map(test => [test.test_name, test])).values()
).map((test, index) => [
  index + 1,
  test.test_name || 'N/A',
  parseFloat(test.test_price || 0).toFixed(2),
  parseFloat(test.test_price || 0).toFixed(2)
]);

autoTable(doc, {
  startY: y,
  head: [['Sl. No', 'Test Name', 'Test Amount', 'Final Amount']],
  body: testData.length
    ? testData
    : [['1', 'N/A', '0.00', '0.00'], ['2', 'N/A', '0.00', '0.00'], ['3', 'N/A', '0.00', '0.00']],
  theme: 'grid',

  // Header should have no fill and bold black text
  headStyles: {
    fillColor: [255, 255, 255], // no fill
    textColor: 0,
    fontStyle: 'bold',
    fontSize: 8,
    valign: 'middle'
  },

  bodyStyles: {
    fontSize: 8,
    textColor: 0,
    valign: 'top'
  },

  // Prevent autoTable from drawing its own cell borders (so we can draw a single thin stroke)
  styles: {
    cellPadding: 1,
    lineWidth: 0,            // disable autoTable lines
    lineColor: [0, 0, 0]
  },

  margin: { left: 10, right: 10 },
  tableWidth: 'auto',

  columnStyles: {
    0: { cellWidth: 25, halign: 'center' },
    1: { cellWidth: 105 },
    2: { cellWidth: 30, halign: 'center' },
    3: { cellWidth: 30, halign: 'center' }
  },

  didDrawCell: function (data) {
    const cell = data.cell;
    if (!cell) return;

    // We only want to stroke the cells (header + body). Skip extras like margin/header groups if present.
    // cell.section is 'head' or 'body' or 'foot'
    if (cell.section === 'head' || cell.section === 'body' || cell.section === 'foot') {
      // set a very thin line width
      doc.setDrawColor(0);        // black
      doc.setLineWidth(0.02);     // <<-- try 0.05; reduce to 0.02 or 0.01 if you want even thinner
      // draw single rect (stroke only)
      doc.rect(cell.x, cell.y, cell.width, cell.height, 'S');
    }
  }
});



  // ==== Amount Section ====
   // ==== Amount Section ====
   y = doc.lastAutoTable.finalY + 5;
   const labelX = 140;
   const valueX = 190;
   const gap = 5;
 
   // compute numeric amounts locally (robust to empty strings)
   const totalAmt = parseFloat(formData.lab_total || 0);
   const discountPct = parseFloat(formData.lab_dis_per || 0);
   const discountamt = parseFloat(formData.lab_fix_deposit || 0);
   const finalAmt = parseFloat(formData.lab_final_amt || 0);
   const paidAmt = parseFloat(formData.lab_paid || 0);
   const dueAmt = parseFloat(formData.lab_due ?? (finalAmt - paidAmt) ?? 0);
 
   doc.setFont("helvetica", "bold").setFontSize(8);
 
   const printLine = (label, value, offset) => {
     const amount = parseFloat(value || 0).toFixed(2);
     doc.text(label, labelX, y + offset);
     doc.text(amount, valueX, y + offset, null, null, 'right');
   };
 
   printLine("Total Amount", totalAmt, 0);
   printLine("Discount(%)", discountPct,gap);
   printLine("Discount Amount", discountamt, gap * 2);
   printLine("Final Amount", finalAmt, gap * 3);
   printLine("Paid Amount", paidAmt, gap * 4);
   printLine("Due Amount", dueAmt, gap * 5);
 
   // ==== Amount in Words ====
   // move words down one more line because we added Due Amount
   const wordsY = y + gap * 5 + 3;
   doc.setFontSize(8).setFont("helvetica", "bold");
   doc.text(`AMOUNT IN WORDS : ${amountInWords(formData.lab_final_amt)} only`, 9, wordsY);
   doc.line(7, wordsY + 2, 200, wordsY + 1);
 

// ==== Footer ====

 const uhid = formData.lab_reg_uhid || "N/A";
  const name = formData.lab_reg_name || "N/A";

  // QR code text
  const qrText = `UHID: ${uhid}\nName: ${name}`;

  // Generate QR code as Base64
  const qrCodeDataURL = await QRCode.toDataURL(qrText, { width: 100 });
// QR Code just above Prepared By
// const footerY = wordsY + 20; // y position for footer area
const qrX = 14; // left side me thoda margin
const qrY = wordsY + 3; // line ke just niche
doc.addImage(qrCodeDataURL, "PNG", qrX, qrY, 16, 16); // QR size 20x20

// Prepared By ka text QR ke right me
doc.setFontSize(8).setFont("helvetica", "normal");
doc.text(`Prepared By: ${Name}`, qrX + 25, qrY + 8); 

// Authorized Signature right side
doc.text("Authorized Signature", 160, qrY + 8);
  // ==== Save ====
const pdfBlob = doc.output('blob');
const pdfUrl = URL.createObjectURL(pdfBlob);

// New tab open karo
const newWindow = window.open(pdfUrl, '_blank');

// Wait karo jab tak tab load na ho
newWindow.onload = function () {
    newWindow.print();
};
//   doc.save(`lab_receipt_${formData.lab_reg_uhid}.pdf`);
};



// Helper function to format date as DD-MM-YYYY
const formatDate = (dateString) => {
  if (!dateString) return "";
  try {
    const date = new Date(dateString);
    return `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
  } catch (e) {
    return dateString;
  }
};
// returns a human-friendly age string or 'N/A' when all parts are zero/absent
const getAgeDisplay = (fd) => {
  if (!fd) return 'N/A';
  const y = Math.max(0, Number(fd.lab_reg_age_year || 0) || 0);
  const m = Math.max(0, Number(fd.lab_reg_age_month || 0) || 0);
  const d = Math.max(0, Number(fd.lab_reg_age_day || 0) || 0);

  if (y === 0 && m === 0 && d === 0) return 'N/A';

  const parts = [];
  if (y > 0) parts.push(`${y} Yr${y > 1 ? 's' : ''}`);
  if (m > 0) parts.push(`${m} M${m > 1 ? '' : ''}`); // "M" for months
  if (d > 0) parts.push(`${d} D${d > 1 ? '' : ''}`); // "D" for days

  return parts.join(' ');
};

// Improved amount in words function
const amountInWords = (amount) => {
  const num = parseFloat(amount);
  if (isNaN(num) || num === 0) return 'Zero';
  
  const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
  const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  
  const convertLessThanThousand = (n) => {
    if (n === 0) return '';
    let res = '';
    
    const hundreds = Math.floor(n / 100);
    if (hundreds > 0) {
      res += units[hundreds] + ' Hundred ';
      n %= 100;
    }
    
    if (n > 0) {
      if (res !== '') res += 'and ';
      
      if (n < 10) {
        res += units[n];
      } else if (n < 20) {
        res += teens[n - 10];
      } else {
        res += tens[Math.floor(n / 10)];
        if (n % 10 > 0) {
          res += ' ' + units[n % 10];
        }
      }
    }
    
    return res.trim();
  };
  
  if (num === 0) return 'Zero';
  
  let result = '';
  let n = num;
  
  // Crores
  const crores = Math.floor(n / 10000000);
  if (crores > 0) {
    result += convertLessThanThousand(crores) + ' Crore ';
    n %= 10000000;
  }
  
  // Lakhs
  const lakhs = Math.floor(n / 100000);
  if (lakhs > 0) {
    result += convertLessThanThousand(lakhs) + ' Lakh ';
    n %= 100000;
  }
  
  // Thousands
  const thousands = Math.floor(n / 1000);
  if (thousands > 0) {
    result += convertLessThanThousand(thousands) + ' Thousand ';
    n %= 1000;
  }
  
  // Hundreds
  result += convertLessThanThousand(n);
  
  return result.trim();
};


  

    // console.log("this is test1 : " +  JSON.stringify(formData.tests1))


    return (
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-xxl-12">

                        <h2 style={{color:"#405189"}}>Lab Registration</h2>
                        <br />
                        {formData.lab_reg_uhid && (
  <div className="alert alert-info alert-dismissible fade show" role="alert">
    <i className="ri-information-line me-2"></i>
    <strong>Patient data loaded</strong> - UHID: {formData.lab_reg_uhid}
    {formData.lab_remarks && formData.lab_remarks.includes('IPD') && (
      <span className="ms-2 badge bg-primary">From IPD</span>
    )}
    <button type="button" className="btn-close" onClick={() => {
      setFormData(prev => ({ ...prev, lab_reg_uhid: "", lab_remarks: "" }));
      setIsUHIDReadOnly(false);
    }}></button>
  </div>
)}
                        <div class="live-preview">
                            <form onSubmit={handleSubmit} noValidate>
                                <div class="card">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <h5 style={{color:"#405189"}}>Patient Details</h5>
                                                <br />
                                            </div>
                                            <div class="col-md-2">
                                               <div className="mb-3">
                <label htmlFor="labRegType" className="form-label">Registration Type</label>
                <select
                    id="labRegType"
                    className="form-control"
                    name="lab_reg_type"
                    onChange={handleChange}
                    value={formData.lab_reg_type}
                    required
                >
                    <option value="Direct">Direct</option>
                    <option value="OPD">OPD</option>
                    <option value="IPD">IPD</option>
                </select>
            </div>
                                            </div>
                                            <div class="col-md-2">
                                               <div className="mb-3">
                <label htmlFor="uhidInput" className="form-label">UHID</label>
 <input
  type="text"
  id="uhidInput"
  className="form-control"
  placeholder="Enter UHID"
  name="lab_reg_uhid"
  onChange={handleChange}
  value={formData.lab_reg_uhid}
  readOnly={isUHIDReadOnly}
  style={{
    backgroundColor: isUHIDReadOnly ? '#e9ecef' : 'white'
  }}
/>


            </div>
                                            </div>
                                            <div class="col-md-2">
                                                
                                                <button id="pop45" style={{ display: "none" }}
                                                    type="button" class="btn btn-success add-btn px-0"
                                                    data-bs-toggle="modal" data-bs-target="#usrModel" fdprocessedid="jys8hw"></button>
                                                <button id="searchbtn" onClick={() => {
                                                    searchUserNow()
                                                }} type="button" class="btn btn-success mt-4 " style={{width: "150px"}}>
                                                    <i class="ri-search-line align-bottom me-1"></i> Search </button>
                                            </div>
                                            <div class="col-md-6">
  <div class="mb-3">
    <div className="d-flex align-items-center justify-content-between">
      <label htmlFor="ageBlock" className="form-label mb-0">Age</label>

      {/* toggle button to set "Unknown / Auto zero" */}
      <div>
       
      </div>
    </div>

    <div class="row mt-2">
      {/* If auto-zero is enabled, show readOnly 0 values (you can hide instead if you prefer) */}
      <div class="col-md-4">
      <input
  ref={ageYearRef}
  type="number"
  className="form-control"
  placeholder="Year"
  name="lab_reg_age_year"
  onChange={handleChange}
  onFocus={handleFocus}
  onBlur={handleBlur}
  value={formData.lab_reg_age_year}
  required
/>

      </div>
      <div class="col-md-4">
        <input
          type="number"
          className="form-control"
          placeholder="Month"
          name="lab_reg_age_month"
          onChange={handleChange}
          onFocus={handleFocus}
  onBlur={handleBlur}
          value={formData.lab_reg_age_month}
         
        />
      </div>
      <div class="col-md-4">
        <input
          type="number"
          className="form-control"
          placeholder="Day"
          name="lab_reg_age_day"
          onChange={handleChange}
          onFocus={handleFocus}
  onBlur={handleBlur}
          value={formData.lab_reg_age_day}
         
        />
      </div>
    </div>
  </div>
</div>


                                            <div class="col-md-6">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div >
                                                            <label for="productname-field" class="form-label">Patient Name</label>
                                                            <div className="row">
  
                                                            <div className="col-md-3">
                                                                <select className="form-control"
                                                                    name="lab_reg_name_title"
                                                                    onChange={handleAutoGenderChange} // 👈 correct here
                                                                    value={formData.lab_reg_name_title}
                                                                    required>
                                                                    <option value="Mr.">Mr.</option>
                                                                    <option value="Mr's">Mr's</option>
                                                                    <option value="Miss">Miss</option>
                                                                    <option value="Master">Master</option>
                                                                    <option value="B/O">B/O</option>

                                                                    <option value="Other">Other</option>
                                                                </select>
                                                            </div>

                                                            <div className="col-md-6">
                                                            <input
  ref={patientNameRef}
  type="text"
  className="form-control"
  placeholder="Enter Name"
  name="lab_reg_name"
  onChange={handleChange}
  value={formData.lab_reg_name}
  required
/>

                                                            </div>

                                                            <div className="col-md-3">
  <select
    className="form-control"
    name="lab_reg_gender"
    value={formData.lab_reg_gender}
    onChange={(e) => {
      // allow manual override
      const val = e.target.value;
      setFormData(prev => ({ ...prev, lab_reg_gender: val }));
      // If you want a manual change to "lock" the gender (prevent title from overriding),
      // you can set a flag here. Example commented out:
      // setIsUHIDReadOnly(false); // or set some other flag like setManualGender(true)
    }}
    required
  >
    <option value="Male">Male</option>
    <option value="Female">Female</option>
    <option value="Other">Other</option>
  </select>
</div>

                                                        </div>

                                                        </div>
                                                    </div>
                                                    <div class="col-md-12"><br /></div>
                                                    <div class="col-md-6">
                                                        <div class="mb-3">
                                                            <label for="firstNameinput" class="form-label">Mobile Number</label>
                                                            <input type="text" class="form-control" placeholder="Enter Mobile Number" name="lab_reg_mobile" onChange={handleChange} value={formData.lab_reg_mobile} required />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div>
                                                            <label for="productname-field" class="form-label">Guardian</label>
                                                            <div class="row">
                                                                <div class="col-md-4">
                                                                    <select class="form-control" name="lab_guardian_title" onChange={handleChange} value={formData.lab_guardian_title}>
                                                                        <option value="C/O">C/O</option>
                                                                        <option value="S/O">S/O</option>
                                                                        <option value="D/O">D/O</option>
                                                                    </select>
                                                                </div>
                                                                <div class="col-md-8">
                                                                    <input type="text" class="form-control"
                                                                        placeholder="Enter Name" name="lab_guardian_name"
                                                                        onChange={handleChange} value={formData.lab_guardian_name}  />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <div class="mb-3">
                                                            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                                                            {/* Label */}
                                                            <div>
                                                                <label htmlFor="firstNameinput" className="form-label mb-0" >
                                                                Referral Doctor
                                                                </label>
                                                            </div>

                                                            {/* Buttons */}
                                                           <div className="d-flex gap-2">
                                                        {/* Hidden trigger button */}
                                                        <button
                                                            id="addbt453"
                                                            style={{ display: "none" }}
                                                            type="button"
                                                            className="btn btn-success add-btn"
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#showModal"
                                                        ></button>

                                                        {/* Visible Add button with smaller size */}
                                                        <button
                                                            type="button"
                                                            className="btn btn-success add-btn h-4 px-3 py-1 mb-2 text-sm"
                                                            onClick={(e) => {
                                                            e.preventDefault();
                                                            document.getElementById("addbt453").click();
                                                            }}
                                                        >
                                                            <i className="ri-add-line align-bottom me-1"></i> Add Doctor
                                                        </button>
                                                        </div>

                                                            </div>

                                                           

{/* use this in place of your old referral block */}
<div className="col-md-12">
  

  <Select
  
    isClearable
    placeholder="Search doctor by name"
    // options built from filteredDoctors or fallback to formData.docs
    options={(filteredDoctors || formData.docs || []).map(d => ({
      value: String(d.user_id ?? d.id ?? ""),
      label: `${(d.fname || "").trim()}${d.lname ? " " + (d.lname || "").trim() : ""}`.trim(),
      meta: {
        speciality: d.doc?.doc_specality || d.cat_name || "",
        degree: d.doc?.doc_degree || d.designation || ""
      },
      raw: d
    }))}

    /* DO NOT pass inputValue (let react-select manage it) */
    onInputChange={(inputValue, { action }) => {
      // keep your docSearch in sync when user types
      if (action === "input-change") {
        setDocSearch(inputValue);
        // optional: also keep lab_reg_referral string for other code
        setFormData(prev => ({ ...prev, lab_reg_referral: inputValue }));
        setReferralId(""); // clear selected id while typing
      }
    }}

    /* value must be the exact option object (or null) */
    value={
      // prefer to find the matching option from current options to ensure react-select can render it
      (() => {
        const allOptions = (filteredDoctors || formData.docs || []).map(d => ({
          value: String(d.user_id ?? d.id ?? ""),
          label: `${(d.fname || "").trim()}${d.lname ? " " + (d.lname || "").trim() : ""}`.trim(),
          raw: d
        }));
        if (referralId) {
          const found = allOptions.find(o => o.value === String(referralId));
          if (found) return found;
          // fallback: use label from formData
          return { value: String(referralId), label: formData.lab_reg_referral || String(referralId) };
        }
        // if no referralId but a name exists (user typed and didn't select), show nothing selected
        return null;
      })()
    }

    onChange={(opt) => {
      if (!opt) {
        // cleared
        setReferralId("");
        setDocSearch("");
        setFormData(prev => ({ ...prev, lab_reg_referral: "" }));
        return;
      }
      const id = opt.value;
      const label = opt.label || (opt.raw && ((opt.raw.fname || "") + " " + (opt.raw.lname || "")).trim()) || "";
      setReferralId(id);
      setDocSearch(label); // optional: prefill the search variable
      setFormData(prev => ({ ...prev, lab_reg_referral: label }));
    }}

    // richer option rows: name + small meta line
    formatOptionLabel={(opt, { context }) => {
      if (context === "menu") {
        return (
          <div>
            <div style={{ fontWeight: 600 }}>{opt.label}</div>
            {/* <div style={{ fontSize: 12, color: "#666" }}>
              {opt.meta?.degree ? opt.meta.degree + (opt.meta?.speciality ? " • " + opt.meta.speciality : "") : (opt.meta?.speciality || "")}
              {opt.value ? ` • ID: ${opt.value}` : null}
            </div> */}
          </div>
        );
      }
      // control view
      return <div>{opt.label}</div>;
    }}

    // avoid clipping by parent containers
    menuPortalTarget={document.body}
    styles={{
      control: (provided) => ({ ...provided, minHeight: '38px', borderRadius: 4 }),
      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      option: (provided) => ({ ...provided, padding: '8px 12px' })
    }}

    noOptionsMessage={() => "No doctor found"}
    isSearchable
    backspaceRemovesValue
  />
</div>






                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="row">

                                                    <div class="col-md-12">
                                                        <div class="mb-3">
                                                            <label for="firstNameinput" class="form-label">Address</label>
                                                            <input type="text" class="form-control"
                                                                placeholder="Enter Address" name="lab_reg_address" onChange={handleChange} value={formData.lab_reg_address}  />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="mb-3">
                                                            <label for="firstNameinput" class="form-label">City</label>
                                                            <input type="text" class="form-control" placeholder="Enter City" name="lab_reg_city" onChange={handleChange}
                                                                value={formData.lab_reg_city}  />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="mb-3">
                                                            <label for="firstNameinput" class="form-label">State</label>
                                                            <input type="text" class="form-control" placeholder="Enter State" name="lab_reg_state" onChange={handleChange}
                                                                value={formData.lab_reg_state}  />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6" style={{ display: 'none' }}>
                                                    
                                                                <div className="mb-3 position-relative" >
  <label htmlFor="lab_collected_at" className="form-label">Collected AT</label>
  
  <input
    type="text"
    className="form-control"
    placeholder="Search Collection Center"
    value={formData.lab_collected_at}
    onChange={(e) => {
      const value = e.target.value;
      setFormData((prev) => ({
        ...prev,
        lab_collected_at: value,
      }));
    }}
    onFocus={() => setShowCollectedDropdown(true)}
    onBlur={() => setTimeout(() => setShowCollectedDropdown(false), 200)} // delay for click
  />

  {showCollectedDropdown && (
    <ul className="list-group position-absolute w-100" style={{ maxHeight: "150px", overflowY: "auto", zIndex: 1000 }}>
      {formData.docs
  .filter((center) =>
    center?.name?.toLowerCase().includes(formData.lab_collected_at.toLowerCase())
  )
  .map((center, index) => (
    <li
      key={index}
      className="list-group-item list-group-item-action"
      onClick={() => {
        setFormData((prev) => ({
          ...prev,
          lab_collected_at: center.name,
        }));
        setShowCollectedDropdown(false);
      }}
      style={{ cursor: "pointer" }}
    >
      {center.name}
    </li>
  ))}

{formData.docs.filter((center) =>
  center?.name?.toLowerCase().includes(formData.lab_collected_at.toLowerCase())
).length === 0 && (
  <li className="list-group-item text-muted">No center found</li>
)}

    </ul>
  )}
</div>


                                                    </div>
                                                    <div class="col-md-6" style={{ display: 'none' }}>
                                                        <div class="mb-3">
                                                            <label for="firstNameinput" class="form-label">Registration Date</label>
                                                            <input type="date" class="form-control" placeholder="Enter Id"
                                                                name="lab_reg_date" onChange={handleChange} value={formData.lab_reg_date} required readOnly />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
  <label className="form-label">Referral Broker</label>
  <Select
    isClearable
    placeholder="Search broker by name or phone..."
    options={brokerOptions}
    isLoading={loadingBrokers}
    onInputChange={(val, action) => {
      if (action === 'input-change') {
        // debounce load
        if (brokerDebounceRef.current) clearTimeout(brokerDebounceRef.current);
        brokerDebounceRef.current = setTimeout(() => loadBrokers(val), 300);
      }
    }}
    onChange={(opt) => {
      if (!opt) {
        setBrokerId(''); setBrokerLabel('');
      } else {
        setBrokerId(String(opt.value)); setBrokerLabel(opt.label || '');
      }
    }}
    value={
      brokerId 
        ? (brokerOptions.find(opt => String(opt.value) === String(brokerId)) || 
           { value: String(brokerId), label: brokerLabel })
        : null
    }
    menuPortalTarget={document.body}
    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
    noOptionsMessage={() => loadingBrokers ? 'Loading...' : 'No brokers'}
  />
</div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <hr />
                                                <h5 style={{color:"#405189"}}>Select Tests</h5>
                                                <div class="card-body border border-dashed border-end-0 border-start-0">
                                                    <form>
                                                        <div class="row g-3">
                                                            <div class="col-xxl-2 col-sm-2"></div>
                                                   <div class="col-xxl-8 col-sm-8">
                                                   <div className="search-box" style={{ position: 'relative' }}>
  <div style={{ position: 'relative' }}>
    <input
      ref={inputRef}
      className="form-control search"
      placeholder="Search tests..."
      type="text"
      name="search_key"
      autoComplete="off"
      value={formData.search_key}
      onChange={handleChange}
      onFocus={() => {
        setShowSearchDropdown(true);
        // fetch a default list when focused and input is empty
        if (!formData.search_key || formData.search_key.trim().length === 0) {
          fetchTests(""); // get default/popular tests
        }
      }}
      onBlur={() => setTimeout(() => setShowSearchDropdown(false), 150)}
    />
    <i className="ri-search-line search-icon"></i>

    {showSearchDropdown && (
      <div
        className="dropdown-menu show w-100"
        style={{
          maxHeight: "120px",
          overflowY: "auto",
          position: "absolute",
          top: "100%",
          left: 0,
          zIndex: 1000,
          display: "block",
          padding: 0,
        }}
      >
        {isLoading ? (
          <div className="dropdown-item text-center p-2">
            <div className="spinner-border spinner-border-sm" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <span className="ms-2">Searching...</span>
          </div>
        ) : searchResults.length === 0 ? (
          <div className="dropdown-item text-muted p-2">No tests found</div>
        ) : (
          searchResults.map((test, idx) => (
            <div
              key={idx}
              className="dropdown-item"
              onMouseDown={(e) => {
                e.preventDefault();
                handleSelTst(test);
              
                // Reset the search input but immediately repopulate the dropdown
                // with the API default list so user can continue selecting more tests.
                setFormData(prev => ({ ...prev, search_key: "" }));
              
                // Immediately fetch default/popular tests (no debounce)
                fetchTests("");
              
                // keep the dropdown open and restore focus to input
                setShowSearchDropdown(true);
                setTimeout(() => inputRef.current?.focus(), 50);
              }}
              
              style={{ cursor: 'pointer', padding: '0.5rem 1rem' }}
            >
              <div>
                <strong>{test.test_name}</strong>
                <div className="text-muted small">
                  {test.cat_name} - ₹{test.test_price}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    )}
  </div>
</div>

            </div>
                                                            {/* <div class="col-xxl-2 col-sm-2">
                                                                <button id="poptst45" type="button" class="btn btn-success add-btn" data-bs-toggle="modal" data-bs-target="#tstrtModal" fdprocessedid="jys8hw">
                                                                    <i class="ri-add-line align-bottom me-1"></i> Add </button>
                                                            </div> */}
                                                        </div>
                                                    </form>
                                                </div>
                                                <br />
                                                <div class="card-body pt-0">
                                                    <div>

                                                        <div class="table-responsive table-card mb-1">
                                                            <table class="table table-nowrap align-middle" id="orderTable">
                                                                <thead class="text-muted table-light" style={{backgroundColor: "#17203b !important"}}>
                                                                    <tr class="text-uppercase">

                                                                        <th style={{ width: "60px"}} data-sort="id">S. No.</th>
                                                                        <th data-sort="customer_name">Test Name</th>
                                                                        <th data-sort="product_name">Price</th>
                                                                        <th data-sort="product_name">Discount</th>
                                                                        <th data-sort="city">Total</th>
                                                                        <th style={{ width: "120px" }} data-sort="city">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody class="list form-check-all">
                                                 {formData.tests1.map((item, index) => (
                                                  
  <tr key={index}>
    <td className="customer_name" data-type={item.id}>{index + 1}.</td>
    <td className="product_name">
  { item.test_name ?? item.lab_item_test_name ?? item._raw?.lab_item_test_name ?? 'N/A' }
</td>
<td className="date">
  { (Number(item.lab_item_total ?? item.test_price ?? item._raw?.lab_item_test_price ?? 0)).toFixed(2) }
</td>


 <td className="date">
  <input
    type="number"
    className="form-control"
    min="0"
    name="test_discount"
    value={item.test_discount ?? 0}   // yahan change
    onChange={(e) => {
      const value = parseFloat(e.target.value);
      const updatedTests = [...formData.tests1];

      // Update discount
      updatedTests[index].test_discount = value;

      // Calculate per test final price & save in lab_item_total
      const price = parseFloat(updatedTests[index].test_price || 0);
      updatedTests[index].lab_item_total = Math.max(price - value, 0);

      // Calculate grand total
      const ttl = updatedTests.reduce((sum, test) => {
        const p = parseFloat(test.test_price || 0);
        const d = parseFloat(test.test_discount || 0);
        return sum + Math.max(p - d, 0);
      }, 0);

      // Update state
      setFormData(prev => ({
        ...prev,
        tests1: updatedTests,
        lab_total: ttl.toFixed(2)
      }));
    }}
  />
</td>


    <td className="date">
      {/* Calculate and show final price for this test */}
      {parseFloat(item.lab_item_total || item.test_price).toFixed(2)}
    </td>

    <td>
      <ul className="list-inline hstack gap-2 mb-0">
        <li className="list-inline-item">
          <a
            href="#!"
            className="text-danger d-inline-block remove-item-btn"
            onClick={(e) => {
              e.preventDefault();
              const updatedTests = [...formData.tests1];
              updatedTests.splice(index, 1);

              // Recalculate total after removal
              const ttl = updatedTests.reduce((sum, test) => {
                const price = parseFloat(test.test_price || 0);
                const discount = parseFloat(test.test_discount || 0);
                return sum + Math.max(price - discount, 0);
              }, 0);

              setFormData(prev => ({
                ...prev,
                tests1: updatedTests,
                lab_total: ttl.toFixed(2)
              }));
            }}
          >
            <i className="ri-delete-bin-5-fill fs-16"></i>
          </a>
        </li>
      </ul>
    </td>
  </tr>
))}


                                                                </tbody>
                                                            </table>

                                                        </div>

                                                    </div>
                                                </div>
                                                <hr />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <h5 style={{color:"#405189"}}>Payment Details</h5>
                                                <br />
                                            </div>
                                            <div class="col-md-3">
                                                <div class="mb-3">
                                                    <label for="firstNameinput" class="form-label">Total Amount</label>
                                                    <input type="number" class="form-control" placeholder="Enter Total Amount"
                                                        name="lab_total" onChange={handleChange} value={formData.lab_total} required readOnly />
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="mb-3">
                                                    <label for="firstNameinput" class="form-label">Discount(%)</label>
                                                    <input type="number" class="form-control" placeholder="Enter Discount"
                                                        name="lab_dis_per" onChange={handleChange} value={formData.lab_dis_per} onFocus={handleFocus}
                                                        onBlur={handleBlur} required />
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="mb-3">
                                                    <label for="firstNameinput" class="form-label">Fixed Discount</label>
                                                    <input type="number" class="form-control" placeholder="Enter Fixed Deposit"
                                                        name="lab_fix_deposit" onChange={handleChange} value={formData.lab_fix_deposit} onFocus={handleFocus}
                                                        onBlur={handleBlur} required />
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="mb-3">
                                                    <label for="firstNameinput" class="form-label">Final Amount</label>
                                                    <input type="number" class="form-control" placeholder="Enter Final Amount"
                                                        name="lab_final_amt" onChange={handleChange} value={formData.lab_final_amt} required readOnly />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="mb-3">
                                                    <label for="firstNameinput" class="form-label">Paid</label>
                                                    <input type="number" class="form-control" placeholder="Enter Paid"
                                                        name="lab_paid" onChange={handleChange} value={formData.lab_paid} onFocus={handleFocus}
                                                        onBlur={handleBlur} required />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="mb-3">
                                                    <label for="firstNameinput" class="form-label">Due</label>
                                                    <input type="text" class="form-control" placeholder="Enter Due"
                                                        name="lab_due" onChange={handleChange} value={formData.lab_due} required readOnly />
                                                </div>
                                            </div>

                                            <div class="col-md-4">
                                                <div class="mb-3">
                                                    <label for="firstNameinput" class="form-label">Pay Mode</label>
                                                    <select class="form-control" name="lab_pay_mode"
                                                        onChange={handleChange} value={formData.lab_pay_mode} required>
                                                        <option value="Cash">Cash</option>
                                                        <option value="Online">Online</option>
                                                        <option value="Card">Card</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="mb-3">
                                                    <label for="firstNameinput" class="form-label">Remarks</label>
                                                    <textarea class="form-control" placeholder="Enter Remarks"
                                                        name="lab_remarks" onChange={handleChange} value={formData.lab_remarks}></textarea>
                                                </div>
                                            </div>
                                            <div class="col-lg-12">
                                                <div class="text-end">
                                                    {formData.lab_reg_id.length > 0 ? <button type="submit" class="btn btn-primary">Update</button> : <button type="submit" class="btn btn-primary">Save</button>}
                                                    &nbsp;&nbsp;&nbsp;<button
  type="button"
  className="btn btn-info"
  disabled={!isSaved || !formData.lab_reg_uhid}
  onClick={() => printThermalBarcodeIframe(formData.lab_reg_name, formData.lab_reg_age_year, formData.lab_reg_uhid)}
>
  Print Barcode
</button>
<canvas ref={barcodeCanvasRef} style={{ display: 'none' }} />


                                                        &nbsp;&nbsp;&nbsp;
                                                    
                                                   <button
        type="button"
        className="btn btn-dark"
        onClick={() => setShowModal(true)}
         disabled ={!isSaved}
      >
        Print Receipt
      </button>

      {/* Modal */}
      {showModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog" style={{ marginTop: "8rem" }}>
            <div className="modal-content">

              <div className="modal-header">
                <h5 className="modal-title">Print Options</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>

             <div className="modal-body">
  <label className="form-label d-block mb-2">Select Header Option</label>

  <div className="form-check">
    <input
      className="form-check-input"
      type="radio"
      name="headerOption"
      id="withHeader"
      value="with"
      defaultChecked
    />
    <label className="form-check-label" htmlFor="withHeader">
      With Header
    </label>
  </div>

  <div className="form-check">
    <input
      className="form-check-input"
      type="radio"
      name="headerOption"
      id="withoutHeader"
      value="without"
    />
    <label className="form-check-label" htmlFor="withoutHeader">
      Without Header
    </label>
  </div>
</div>


              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                 
              onClick={() => {
  const headerOption = document.querySelector(
    'input[name="headerOption"]:checked'
  ).value;
  generatePDF(headerOption);
  setShowModal(false);
}}

                >
                  Proceed to Print
                </button>
              </div>

            </div>
          </div>
        </div>
          )}
                                                    &nbsp;&nbsp;&nbsp;
                                                  <a href="/lab_patient_list" class="btn btn-danger">Cancel</a>
                                                   
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </form>
                        </div>
                    </div>

                </div>
            </div>
            <AddDoctor  onAddDepart={handleAddDepart}/>
        </div>
    );
}

export default Registrations;
